import { render, staticRenderFns } from "./ExpedientDetailView.vue?vue&type=template&id=513eb018&lang=pug"
import script from "./ExpedientDetailView.vue?vue&type=script&lang=ts"
export * from "./ExpedientDetailView.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientDetailView.vue?vue&type=style&index=0&id=513eb018&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513eb018')) {
      api.createRecord('513eb018', component.options)
    } else {
      api.reload('513eb018', component.options)
    }
    module.hot.accept("./ExpedientDetailView.vue?vue&type=template&id=513eb018&lang=pug", function () {
      api.rerender('513eb018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/ExpedientDetailView.vue"
export default component.exports